import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { DateRangePicker } from 'fw/forms';
import { QuerySearch } from 'areas/shared/pages/query';
import { UserAuto, AuditActionCombo } from 'areas/shared/controls'
import DateRangeHelper from 'fw/forms/helpers/DateRangeHelper'

class Search extends QuerySearch {
    initialForm() {
        return {
            userId: null,
            userName: null,
            actionCode: null,
            date: new DateRangeHelper().thisWeek()
        }
    }

    renderForm() {
        return (
            <div>
                <Row>
                    <Col md={3}>
                        <UserAuto
                            name="userId"
                            label="userName"
                            placeholder="All Users"
                            ref={(c) => { this.focusControl = c }}
                            clearable />
                    </Col>
                    <Col md={3}>
                        <AuditActionCombo name="actionCode" placeholder="All Actions" clearable />
                    </Col>
                    <Col md={3}>
                        <DateRangePicker name="date" />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <span className="log">Date</span>
                    </Col>
                    <Col md={2}>
                        <span className="log">User Name</span>
                    </Col>
                    <Col md={2}>
                        <span className="log">Action</span>
                    </Col>
                    <Col md={6}>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default Search;


// WEBPACK FOOTER //
// ./src/areas/admin/auditReview/Search.js